import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'filesize',
	standalone: false,
})
export class FileSizePipe implements PipeTransform {
	transform(bytes: number): string {
		if (bytes == null || isNaN(Number(bytes))) {
			return '';
		}

		const units = ['B', 'KB', 'MB', 'GB', 'TB'];
		let value = Math.abs(Number(bytes));
		let unitIndex = 0;
		while (value >= 1024 && unitIndex < units.length - 1) {
			value /= 1024;
			unitIndex++;
		}

		const digits = unitIndex === 0 || value >= 10 ? 0 : 1;
		return `${value.toFixed(digits)} ${units[unitIndex]}`;
	}
}
